import { render, staticRenderFns } from "./TopicSlider.vue?vue&type=template&id=7eeedc4d&scoped=true"
import script from "./TopicSlider.vue?vue&type=script&lang=js"
export * from "./TopicSlider.vue?vue&type=script&lang=js"
import style0 from "./TopicSlider.vue?vue&type=style&index=0&id=7eeedc4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eeedc4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSlideYTransition})
